import styled from 'styled-components'

export const PhenotypicDisplayStandard = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
`

export const PhenotypicDisplayTable = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const PhenotypicDisplaySql = styled.div`
  max-height: 120px;
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
`

export const QueryChipsContainer = styled.div`
  display: flex;
  align-items: center;

  > div {
    border-style: none;
  }
`
